import React from "react";

import {
  Divider,
  Flex,
} from "@patternfly/react-core";

import SchoolHeaderBip from "../SchoolHeaderBip/SchoolHeaderBip";
import SchoolHeaderSocials from "../SchoolHeaderSocials/SchoolHeaderSocials";

const SchoolHeaderActions = ({ variant = "desktop" }) => {
  return (
    <Flex
      alignItems={{ default: "alignItemsCenter" }}
      spaceItems={{ default: "spaceItemsMd" }}
      flexWrap={{ default: "nowrap" }}
    >
      <SchoolHeaderBip variant={variant} />

      <Divider
        orientation={{
          default: "vertical",
        }}
      />

      <SchoolHeaderSocials variant={variant} />
    </Flex>
  );
};

export default SchoolHeaderActions;